import { render, staticRenderFns } from "./SellBody.vue?vue&type=template&id=1cf53c50"
import script from "./SellBody.vue?vue&type=script&lang=js"
export * from "./SellBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports